import { render, staticRenderFns } from "./AffinityTotals.vue?vue&type=template&id=5a16de8c"
import script from "./AffinityTotals.vue?vue&type=script&lang=js"
export * from "./AffinityTotals.vue?vue&type=script&lang=js"
import style0 from "./AffinityTotals.vue?vue&type=style&index=0&id=5a16de8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports